import { Market, PrivacySettingToggles } from '../types/market';
import { ie as adConfig } from '../ads';

const market: Market = {
  countryCode: 'ie',
  active: false,
  permanentRedirect: true,
  sitename: 'PriceSpy',
  superSearchEndpoint: 'https://search.pricespy.ie/rfe',
  redirectHosts: ['m.pricespy.ie', 'www.pricespy.ie'],
  trackerProxy: 'rfe-tracker-2069617015.eu-west-1.elb.amazonaws.com',
  classicProxy: {
    host: 'int-classic-ie.prisjakt.io',
    port: 8080,
  },
  hrefLang: ['en-IE'],
  locale: 'en-ie',
  sites: {
    production: 'https://pricespy.ie',
    classic: 'https://classic.pricespy.ie',
    analytics: 'https://classic.pricespy.ie/analytics/store/',
    brands: undefined,
    forum: undefined,
  },
  api: {
    default: 'http://int-api-ie.prisjakt.io:8080/v1',
  },
  googleSiteVerification: '-6T8RmxC4QpOb2OVAJgPT8XtRHG_MNvlavAi833riEI',
  campaigns: {
    base:
      'https://search-pj-campaigns-index-oyaq7ruf3du2owxiiiuhyqcgcm.eu-west-1.es.amazonaws.com',
    previousCampaignDates: {
      '16': '2019-11-11', // Singles day
    },
  },
  googleTagManager: 'GTM-KD9S55X',
  amp: {
    enabled: true,
    tracking: {
      googleTagManager: 'GTM-5NK99DW',
      facebookPixel: '1502734043352861',
    },
  },
  translation: 'en_IE',
  timezone: 'Europe/Dublin',
  currencyCode: 'EUR',
  url: {
    campaigns: '/theme',
    legacy: {
      brand: '/brand.php',
      category: '/category.php',
      fight: '/fight.php',
      forum: undefined,
      info: '/info.php',
      lists: '/lists.php',
      minhembio: undefined,
      plugin: '/plugins/',
      product: '/product.php',
      raw: '/raw.php',
      store_info: '/shop.php',
      user_login: '/login/login.php',
      mobile_site: 'https://m.pricespy.ie',
    },
  },
  socialNetworks: {
    instagram: {
      link: 'https://www.instagram.com/pricespyie/',
    },
    facebook: {
      enableLogin: true,
      link: 'https://www.facebook.com/PriceSpyIE',
      clientID: '434273480036687',
      clientSecret: '73ac1c7708131d3dd76c9c61f7110137',
      callbackURL: `/_internal/auth/facebook/callback`,
    },
    twitter: {
      // @TODO: Twitter accounts created on RFE platform fails to authorize. Disable until we can find out why.
      enableLogin: false,
      link: 'https://twitter.com/PriceSpyIE',
      consumerKey: 'pn7XgSBs3C2GeZfioggPBVr6k',
      consumerSecret: 'Wpy6iRP1IQhRbMPM2bZr1tLsZoQUUbaCYVWrQVb9Tj0RvYMYNU',
      callbackURL: `/_internal/auth/twitter/callback`,
    },
  },
  email: {
    noreply: 'noreply@pricespy.ie',
  },
  cdn: {
    base: 'https://pricespy-75b8.kxcdn.com',
    images: 'https://pricespy-75b8.kxcdn.com/',
  },
  routes: {
    themes: {
      path: '/theme',
    },
    campaign: {
      path: '/theme/:name',
    },
  },
  popularCampaignFilterPaths: [
    {
      title: 'Best TV deals under € 1000',
      path: '?category=107&price=1-1000&sort=rank%7Cdesc',
    },
    {
      title: 'Best deals under € 50',
      path: '?sort=rank%7Cdesc&price=1-50',
    },
    {
      title: 'Best deals € 50-100',
      path: '?sort=rank%7Cdesc&price=50-100',
    },
    {
      title: 'Most popular perfumes',
      path: '?sort=product.popularity.total&category=965',
    },
  ],

  infoPages: [9, 5, 15, 10, 12, 4, 13, 6, 14, 7, 8],
  infoPageMap: {
    userAgreement: 4,
    priceInformation: 5,
    privacyPolicy: 6,
    cookiePolicy: 7,
    contact: 8,
    about: 9,
    registerShop: 10,
    media: 12,
    disclaimer: 14,
    aboutReviews: 15,
    adlink: 'adlink',
    themes: 'themes',
    articles: 'articles',
  },
  newsletter: {
    apiUrl: 'https://api.getanewsletter.com/v3/',
    apiKey:
      '8KV6mYjfJmudQnsQGIm1ba/oRw/hcDhaDiuvgz2yT8f8NfKzl017dhGEpHPOAxQVLiUq4ZibYSS9c6aQuWqaKjByShyixwZjSZgh1cJlSzvDdDx7G1L4+uo5UTV6TFV0xqRIUW4PmgCdXk16Cnzds6a4aImDyrsRO/8eszpZG2g8D5bNcy+t2xBU+eh1LFUZ96CJrs4DzWOMfIOrWs/F61fZJHU5GGNG6QVjiZ4STok+mUD+NEezTNHDVIySuT4',
    list: '9ggTEK',
    gansubFormId: 'b8WqrEFSZQgst',
  },
  apps: {
    ios: '369151774',
    android: 'se.prisjakt.pricespy',
  },
  priceList: {
    showInternational: true,
  },
  ads: { active: true, ...adConfig },
  privacySettings: {
    responsive: {
      cookieVersion: '4',
      cookieUrl: '/info/cookies--i7',
      privacyUrl: '/info/privacy-policy--i6',
      privacySettingsUrl: '/privacy-settings',
    },
    desktop: {
      cookieVersion: '4',
      cookieUrl: '/info.php?t=about_cookies',
      privacyUrl: '/info.php?t=about_privacy',
      privacySettingsUrl: '/privacy.php',
    },
    mobile: {
      cookieVersion: 'hidden', // policy_banner
      cookieUrl: '/about/cookies',
      privacyUrl: '/about/privacy',
      privacySettingsUrl: '/privacy/settings',
    },
    native: {
      cookieVersion: 'hidden', // policy_banner
      cookieUrl: '/about/cookies',
      privacyUrl: '/about/privacy',
      privacySettingsUrl: '/privacy/settings',
    },
  },
  structuredData: {
    '@context': 'http://schema.org',
    '@type': 'Organization',
    legalName: 'PriceSpy Ireland',
    areaServed: 'IE',
    url: 'https://pricespy.ie',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '22 Northumberland Road',
      addressLocality: 'Ballsbridge',
      postalCode: 'Dublin 4',
      addressCountry: 'Ireland',
    },
    logo: 'https://pricespy-75b8.kxcdn.com/g/rfe/logos/logo_ie.svg',
    sameAs: [
      'https://www.facebook.com/PriceSpyIE',
      'https://twitter.com/pricespyie',
    ],
  },
  modules: {
    priceInfo: {
      enabled: false,
    },
    categoryInfo: {
      enabled: false,
    },
    userReviewPurchaseDate: {
      enabled: false,
    },
    readableProductInfo: {
      enabled: true,
    },
  },
  showClassicSwitch: false,
  showProductInformationTexts: true,
  trackingToggles: [
    { name: PrivacySettingToggles.BehaviourTrackingImprovement, default: true },
    { name: PrivacySettingToggles.BehaviorTrackingMarketing, default: false },
    { name: PrivacySettingToggles.BehaviorTrackingSurveys, default: true },
    { name: PrivacySettingToggles.PersonalizedAds, default: true },
    { name: PrivacySettingToggles.Personalization, default: true },
  ],
  shopOfTheYear: {},
  cdnCache: {
    enabled: true,
    mode: 'external',
  },
};

export default market;
